import React from "react";
import { Three } from "./Chart.config";
import ShreeDayTable from "./ShreeDayTable";

const ShreeDay = ({ chartData }) => {
   return <ShreeDayTable staticData={Three} chartData={chartData} />;
 
};

export default ShreeDay;
